const Filter = (props) => {
  const filter = props.click
  return (
    <div className="filter-box relative">
      <button type="button" className="apply-filter-btn relative d-flex align-center" onClick={filter}>
        <img src="/images/apply-filter-icon.svg" alt="apply_filter" /> Apply Filter
      </button>
    </div>
  );
};

export { Filter };